module.exports = __webpack_public_path__ + "static/img/6.43dd0cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/sp/6.png
// module id = z8+x
// module chunks = 0